import { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from './auth/authConfig';
import Header from './components/Header';
import EnvironmentList from './components/EnvironmentList';
import CreateEnvironment from './components/CreateEnvironment';
import './App.css';

function App() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Handle redirect after login
    instance.handleRedirectPromise().finally(() => {
      setLoading(false);
    });
  }, [instance]);

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1>Ephemeral Environment Manager</h1>
          <p>Sign in with your Azure AD account to manage ephemeral environments.</p>
          <button onClick={handleLogin} className="login-button">
            Sign in with Microsoft
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <CreateEnvironment />
        <EnvironmentList />
      </main>
    </div>
  );
}

export default App;
